import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/alura-tracker-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3103af8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Alura Tracker"
  })
], -1))
const _hoisted_2 = { class: "painel mt-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tasks" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Tasks ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-project-diagram" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Projects ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", null, [
    _hoisted_1,
    _createElementVNode("button", {
      class: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeTheme && _ctx.changeTheme(...args)))
    }, _toDisplayString(_ctx.buttonText), 1),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/",
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/projects",
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}